<script setup lang="ts">
import { generateUUID } from '@/utils/strings';
import type { FormControl } from "@/utils/forms";
import { computed } from 'vue';

const props = withDefaults(defineProps<{
    control: FormControl<string>;
    label?: string;
    icon?: string;
    placeholder?: string;
    disabled?: boolean;
    readOnly?: boolean;
    rows?: number;
}>(), {
    icon: 'fas fa-align-left',
    rows: 6
});

const emit = defineEmits<{
    (e: 'blur', value: any): void;
}>();

const id = generateUUID();

const cssClass = computed(() => {
    return {
        'e-input-focus': props.control.focused,
        'e-error': props.control.errors.length && props.control.touched,
        'e-disabled': props.disabled,
        'e-ready-only': props.readOnly,
    }
})


</script>

<template>
    <div>
        <label v-if="label" class="e-label" :for="id">{{ label }} <span class="e-error"
                v-if="control.isRequired">*</span></label>
        <div class="e-input-group" :class="cssClass">
            <span v-if="icon && rows <= 4" class="e-input-group-icon" :class="icon"></span>
            <textarea :rows="rows" :id="id" class="e-input" v-model="control.value" :placeholder="placeholder"
                @focus="control.markAsFocused" @blur="control.markAsUnfocused(); emit('blur', control.value)"
                @keydown.stop> </textarea>
        </div>
        <div class="e-error" v-if="control.touched" v-for="error in control.errors">{{ error }}</div>
    </div>
</template>

<style lang="scss" scoped>
textarea {
    resize: none !important;
}
</style>